import { RouterView } from "vue-router";
import { CheckRouting } from "./check/check.routing";
import { ChangeRouting } from "./change/change.routing";
import { ReceiveRouting } from "./receive/receive.routing";

export const SafetyRouting = {
  path: "/safety",
  name: "safety",
  redirect: "/safety/check/list",
  component: RouterView,
  meta: { title: "安全管理", icon: "anquan" },
  children: [...CheckRouting, ...ChangeRouting, ...ReceiveRouting],
};
